import { createStyles, WithStyles, withStyles } from '@mui/styles';
import classnames from 'classnames';
import * as React from 'react';
import { connect } from 'react-redux';
import { TStore } from '../../../state/store';
import { KwiffTheme } from '../../../theme';

export interface Props {
  inboxBadge: number;
  onClick?: () => undefined;
}

class InboxBadge extends React.Component<Props & WithStyles<typeof styles>> {
  public render(): React.ReactNode {
    const { classes, inboxBadge } = this.props;

    return inboxBadge > 0 ? (
      <div
        className={classnames(classes.circled, {
          [classes.circledOneDigit]: inboxBadge < 10,
          [classes.circledTwoDigits]: inboxBadge >= 10 && inboxBadge < 100,
          [classes.circledThreeDigits]: inboxBadge >= 100,
        })}
      >
        {inboxBadge < 100 ? (
          inboxBadge
        ) : (
          <span className={classes.largeNumberPlaceholder}>
            <span>{'99'}</span>
            <span className={classes.plus}>{'+'}</span>
          </span>
        )}
      </div>
    ) : null;
  }
}

const styles = (theme: KwiffTheme) =>
  createStyles({
    circled: {
      cursor: 'pointer',
      color: theme.palette.common.white,
      backgroundColor: theme.custom && theme.custom.inboxRed,
      borderRadius: '50%',
      textAlign: 'center',
      fontSize: '12px',
    },
    circledOneDigit: {
      height: '22px',
      width: '22px',
      lineHeight: '22px',
    },
    circledTwoDigits: {
      height: '24px',
      width: '24px',
      lineHeight: '24px',
    },
    circledThreeDigits: {
      height: '28px',
      width: '28px',
      lineHeight: '28px',
    },
    largeNumberPlaceholder: {
      fontSize: '11px',
      display: 'grid',
      gridTemplateColumns: 'auto auto',
      alignItems: 'center',
      justifyContent: 'center',
    },
    plus: {
      fontSize: '15px',
      fontWeight: 400,
    },
  });

const mapStateToProps = (store: TStore) => ({
  inboxBadge: store.userData.inboxBadge,
});

export default connect(mapStateToProps)(withStyles(styles)(InboxBadge));
